export default __webpack_public_path__ + "static/column-pescatarian-1-0b76460408278b1ecb2e0fec651cf78f.jpg";